import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import useNotificationStore from '../../../store/notification';
import { NotificationType } from '@visualizer/types';

type SaveCameraDialogProps = {
    open: boolean;
    onCancel: () => void;
    onSave: (name: string) => Promise<void>;
};

const SaveCameraDialog: React.FC<SaveCameraDialogProps> = ({ open, onCancel, onSave }) => {
    const [name, setName] = useState('');
    const [saving, setSaving] = useState(false);
    const showNotification = useNotificationStore((state) => state.showNotification);

    useEffect(() => {
        if (open) {
            setName('');
            setSaving(false);
        }
    }, [open]);

    const handleClose = (_event: unknown, _reason?: string) => {
        if (saving) {
            return;
        }
        onCancel();
    };

    const handleSave = async () => {
        const trimmedName = name.trim();
        if (!trimmedName) {
            showNotification('Name cannot be empty', NotificationType.Warning);
            return;
        }

        try {
            setSaving(true);
            await onSave(trimmedName);
            setSaving(false);
            onCancel();
        } catch (error) {
            console.error('Failed to save camera', error);
            setSaving(false);
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
            <DialogTitle>Save camera</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Camera name"
                    fullWidth
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                    disabled={saving}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} disabled={saving}>
                    Cancel
                </Button>
                <Button onClick={handleSave} variant="contained" disabled={saving}>
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SaveCameraDialog;
